import gql from 'graphql-tag'

export const uploadUsageLocationDisplayDetailsFragments = gql`
  fragment UploadUsageLocationDisplayDetails on UploadUsageLocation {
    __typename
    ... on IssueUploadUsageLocation {
      issue {
        id
        name
      }
    }
    ... on IssueCommentUploadUsageLocation {
      comment {
        id
      }
      issue {
        id
        name
      }
    }
    ... on StepUploadUsageLocation {
      step {
        id
        name
      }
      module {
        id
        name
      }
      bop {
        ...UploadUsageLocationBOPDetails
      }
    }
    ... on StepImageUploadUsageLocation {
      step {
        id
        name
      }
      module {
        id
        name
      }
      bop {
        ...UploadUsageLocationBOPDetails
      }
    }
    ... on ProductUploadUsageLocation {
      product {
        id
        name
      }
    }
    ... on ProductConfigurationUploadUsageLocation {
      productConfiguration {
        id
        name
        product {
          id
          name
        }
      }
    }
    ... on IconUploadUsageLocation {
      icon {
        id
        name
      }
    }
    ... on ToolImageUploadUsageLocation {
      tool {
        id
        name
      }
      site {
        id
        name
      }
    }
    ... on BOPUploadUsageLocation {
      bop {
        ...UploadUsageLocationBOPDetails
      }
    }
    ... on CheckUploadUsageLocation {
      step {
        id
        name
      }
      module {
        id
        name
      }
      bop {
        ...UploadUsageLocationBOPDetails
      }
    }
  }
  fragment UploadUsageLocationBOPDetails on BOP {
    id
    version
    productConfiguration {
      id
      name
      product {
        id
        name
      }
    }
    site {
      id
      name
    }
  }
`
